import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-to-be-paid-edit',
  templateUrl: './to-be-paid-edit.component.html',
  styleUrls: ['./to-be-paid-edit.component.css'],
})
export class ToBePaidEditComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
